(function (angular) {
    'use strict';

    angular.module("smsReports")
        .controller("SingleChannelCtrl", [
            "$scope", '$timeout', '$stateParams', 'channelsService', 'growlService', 'chartsService', 'chartFactoryService', 'channelsData', 'countries', 'sharedChannelService', function ($scope, $timeout, $stateParams, channelsService, growlService, chartsService, chartFactoryService, channelsData, countries, sharedChannelService) {
                var mode = "singleChannel";
                var channelId = $stateParams.channel;
                $scope.noData = {};

                function primaryValue() {
                    return Math.round(($scope.circleData.primaryValue / ($scope.circleData.success ? $scope.circleData.success : 1)) * 100);
                }

                function secondaryValue() {
                    return Math.round(($scope.circleData.secondaryValue / ($scope.circleData.success ? $scope.circleData.success : 1)) * 100);
                }

                $scope.channels = sharedChannelService.getChannels(mode, primaryValue, secondaryValue);

                $scope.circleData = {};

                function filterChannelData() {
                    sharedChannelService.filterChannelData(mode, channelsData, $scope.channels, primaryValue, secondaryValue);
                    $scope.channel = $scope.channels[channelId];
                }
                filterChannelData();

                $scope.colors = {
                    success: ['#06c0e1', '#3111e4'],
                    delivered: ['#b4ec51', '#429321'],
                    undeliverable: ['#ef473a', '#cb2d3e'],
                    expired: ['#1e130c', '#9a8478'],
                    filtered: ['#734b6d', '#42275a'],
                    inbound: ['#ff9068', '#ff4b1f'],
                    read: ['#b2fefa', '#0ed2f7'],
                    queued: ['#ffe259', '#ffa751'],
                };
                var mainData = {};
                var data = {};

                var countryData = {};
                var timeToDeliveredData = {};

                Chart.elements.Rectangle.prototype.draw = chartFactoryService.roundedCornersBars;
                Chart.pluginService.register(chartFactoryService.fillScatteredTimeScaleDataPlugin);

                var maxYvalue;

                $scope.getData = function () {
                    chartsService.setData($scope.query.from, $scope.query.to, $scope.query.system);
                    $scope.query.by = chartsService.getSampling();
                    $scope.noData.circles = false;
                    $scope.noData.scatter = false;
                    $scope.noData.bar = false;
                    channelsService.getQueriedData($stateParams.pickedApiSpaceId, chartsService.data).then(function (result) {

                        mainData = {};
                        data = {};

                        var scatterIsZeroed = [];
                        maxYvalue = 0;
                        $scope.channel.statuses.forEach(function (status) {

                            mainData[status.id] = [];

                            if (result && result.length > 0) {
                                result.forEach(function (el) {
                                    var val = 0;
                                    if (el[status.id]) {
                                        val = el[status.id][channelId] ? el[status.id][channelId] : 0;
                                    }
                                    mainData[status.id].push({ x: moment(el.date), y: val });
                                    maxYvalue = maxYvalue > val ? maxYvalue : val;

                                });

                            } else {
                                $scope.noData.scatter = true;
                            }

                            data[status.id] = _.reduce(result, function (sum, el) {
                                if (el[status.id] && el[status.id][channelId]) {
                                    return sum + el[status.id][channelId];
                                } else {
                                    return sum;
                                }
                            }, 0);

                            scatterIsZeroed.push(_.some(mainData[status.id], function (el) { return el.y != 0; }));

                        });

                        $scope.noData.scatter = _.compact(scatterIsZeroed).length < 1;

                        $scope.labels = {};

                        $scope.data = {};

                        $scope.labels[channelId] = $scope.channel.statuses.map(function (status) {
                            return status.label;
                        });
                        $scope.data.bar = _.flatMap(data);
                        $scope.noData.bar = _.compact($scope.data.bar).length < 1;

                        var primaryId = $scope.channel.primaryCircle.id;
                        var secondaryId = $scope.channel.secondaryCircle.id;


                        $scope.circleData.success = data.success;
                        $scope.circleData.primaryValue = data[primaryId];
                        $scope.circleData.secondaryValue = data[secondaryId];
                        $scope.noData.circles = ($scope.channel.primaryCircle.value() == 0 && $scope.channel.secondaryCircle.value() == 0);


                        if ($scope.channel.displayCountrySplit) {
                            channelsService.getQueryDataCountrySplit($stateParams.pickedApiSpaceId, chartsService.data).then(function (countryResult) {
                                countryData = {};
                                var tempCountryData = {};
                                countryResult.forEach(function (el) {
                                    if (el.recipientCountryCode) {
                                        if (!tempCountryData[el.recipientCountryCode]) {
                                            tempCountryData[el.recipientCountryCode] = 0;
                                        }
                                        if (el.success) {
                                            tempCountryData[el.recipientCountryCode] += el.success.sms || 0;
                                        } else {
                                            tempCountryData[el.recipientCountryCode] += 0;
                                        }

                                        for (var countryCode in tempCountryData) {
                                            var country = countries.find(function (countryObject) {
                                                return countryObject.twoCharacterCode === countryCode;
                                            });
                                            countryData[country ? country.name : countryCode] = tempCountryData[countryCode];
                                        }
                                    }

                                });
                                $scope.noData.countrySplit = _.size(countryData) < 1;

                                $timeout(displayCountrySplit);

                            }).catch(function (error) {
                                console.error(error);
                                $scope.noData.countrySplit = true;
                            });
                        } else {
                            $scope.noData.countrySplit = true;
                        }


                        if ($scope.channel.displayDeliveryOverTime) {
                            channelsService.getQueriedMetricsAgregated($stateParams.pickedApiSpaceId, chartsService.data).then(function (result) {
                                if (result[0] && result[0][channelId]) {
                                    timeToDeliveredData = result[0][channelId].timeToDelivered;
                                    $scope.noData.delivery = _.size(timeToDeliveredData) < 1;
                                } else {
                                    $scope.noData.delivery = true;
                                }

                                $timeout(displayDelivery);

                            });
                        } else {
                            $scope.noData.delivery = true;
                        }


                        $scope.displayVariables();
                        growlService.success('Data correctly downloaded', 10, true);

                    }).catch(function (error) {
                        growlService.danger("Data didn't downloaded due to: " + error.statusText);
                        console.error(error);
                    });
                };

                var ctx = {};
                var charts = {};
                var chartData = {};

                $scope.displayVariables = function () {

                    var barGradientArray = [];
                    var barGradient = {};
                    var lineGradientSet = {};
                    // var legendColorSet = {};

                    ctx.main = document.getElementById('scatter');
                    ctx.bar = document.getElementById('bar');


                    if (ctx.bar && ctx.main) {
                        ctx.barCanvas = ctx.bar;
                        ctx.bar = ctx.bar.getContext("2d");
                        ctx.main = ctx.main.getContext("2d");

                        // Creating gradients

                        $scope.channels[channelId].statuses.forEach(function (status) {

                            barGradient[status.id] = ctx.bar.createLinearGradient(0, 0, 400, 0);
                            lineGradientSet[status.id] = ctx.main.createLinearGradient(0, 0, 400, 0);

                            lineGradientSet[status.id].addColorStop(0, $scope.colors[status.id][0]);
                            lineGradientSet[status.id].addColorStop(1, $scope.colors[status.id][1]);


                            barGradient[status.id].addColorStop(0, $scope.colors[status.id][0]);
                            barGradient[status.id].addColorStop(1, $scope.colors[status.id][1]);

                            barGradientArray.push(barGradient[status.id]);

                        });


                        //  MAIN SCATTER CHART  
                        var dataSets = [];

                        _.forEach(mainData, function (data, key) {
                            var mainLabel = $scope.channel.statuses.find(function (mainStatus) {
                                return mainStatus.id === key;
                            }).label;
                            dataSets.push(chartFactoryService.singleChannelDataSetMain(mainLabel, data, lineGradientSet[key], lineGradientSet[key], $scope.colors[key][1]));
                        });

                        chartData.main = {
                            datasets: dataSets
                        };

                        if (charts.main) {
                            charts.main.destroy();
                        }

                        charts.main = new Chart(ctx.main, {
                            type: "scatter",
                            data: chartData.main,
                            tooltips: false,
                            options: chartFactoryService.singleChannelDataOptionsMain(chartsService.data.from.value, chartsService.data.to.value, chartsService.data.by, maxYvalue)
                        });



                        // BAR CHART 
                        chartData.bar = {
                            labels: $scope.labels[channelId],
                            datasets: [chartFactoryService.singleChannelDataSetBar(barGradientArray, $scope.data.bar)]
                        };

                        if (charts.bar) {
                            charts.bar.destroy();
                        }

                        ctx.barCanvas.style.width = "100%";
                        ctx.barCanvas.width = ctx.barCanvas.offsetWidth;

                        charts.bar = new Chart(ctx.bar, {
                            type: 'horizontalBar',
                            data: chartData.bar,
                            tooltips: false,
                            options: chartFactoryService.singleChannelDataOptionsBar
                        });

                    }

                };

                //DELIVERY OVER TIME CHART
                function displayDelivery() {


                    ctx.deliverOverTime = document.getElementById('deliverOverTime');

                    if (ctx.deliverOverTime) {
                        ctx.deliverOverTime = ctx.deliverOverTime.getContext("2d");

                        var deliveryColors = [];
                        var deliverOverTimeData = [];

                        var deliveryOverTimeLabels = ["< 10s", "10s - 30s", "30s - 1m", "1m - 5m", "5m - 30m", "30m - 1hr", "> 1hr"];
                        var defaultDeliveryOverTimeSpans = [10, 30, 60, 60 * 5, 60 * 30, 60 * 60, "exceeded"];

                        defaultDeliveryOverTimeSpans.forEach(function (timeSpan) {
                            if (timeToDeliveredData[timeSpan]) {
                                deliverOverTimeData.push(timeToDeliveredData[timeSpan].count);
                            } else {
                                deliverOverTimeData.push(0);
                            }
                        });

                        var startColor = "#06c0e1";
                        var endColor = "#3111e4";
                        var deliverySum = deliverOverTimeData.reduce(function (a, b) {
                            return a + b;
                        }, 0) || 1;
                        _.forEach(deliveryOverTimeLabels, function (data, key) {

                            var gradientSet = ctx.deliverOverTime.createLinearGradient(0, 0, 0, 300);
                            gradientSet.addColorStop(0, endColor);
                            gradientSet.addColorStop(1, startColor);

                            deliveryColors.push(gradientSet);
                        });

                        chartData.deliverOverTime = {
                            labels: deliveryOverTimeLabels,
                            datasets: [chartFactoryService.singleChannelDataSetDelivery(deliverOverTimeData, deliveryColors)],
                        };

                        if (charts.deliverOverTime) {
                            charts.deliverOverTime.destroy();
                        }

                        charts.deliverOverTime = new Chart(ctx.deliverOverTime, {
                            type: 'bar',
                            data: chartData.deliverOverTime,
                            options: chartFactoryService.singleChannelDataOptionsDeliver(deliverySum)
                        });
                    }

                }

                function displayCountrySplit() {
                    // CIRCLE CHART
                    ctx.circle = document.getElementById('countryCircle');

                    if (ctx.circle) {
                        ctx.circle = ctx.circle.getContext("2d");
                        var labels = [];
                        var pieColors = [];
                        var defaultColors = [];
                        var countryDataValues = [];
                        _.forEach(countryData, function (data, key) {
                            var generatedColor = sharedChannelService.stringToColor(key);

                            var gradientSet = ctx.circle.createLinearGradient(150, 0, 450, 400);
                            gradientSet.addColorStop(1, generatedColor);
                            gradientSet.addColorStop(0, sharedChannelService.shadeColor(generatedColor, 0.6));
                            labels.push(key);
                            defaultColors.push(generatedColor);
                            pieColors.push(gradientSet);
                            countryDataValues.push(data);
                        });

                        chartData.circle = {
                            defaultColors: defaultColors,
                            labels: labels,
                            datasets: [chartFactoryService.singleChannelDataSetPie(countryDataValues, pieColors)],
                        };

                        if (charts.circle) {
                            charts.circle.destroy();
                        }

                        charts.circle = new Chart(ctx.circle, {
                            type: 'pie',
                            data: chartData.circle,
                            options: chartFactoryService.singleChannelDataOptionsPie
                        });

                        $("#pieLegend").html(charts.circle.generateLegend());
                    }


                }

                $scope.query = {
                    from: {
                        value: moment().startOf('month').toDate()
                    },
                    to: {
                        value: moment().toDate()
                    },
                    system: 'all'
                };

                $scope.$emit('reports:channels:stateChange', $scope.query);


                $scope.$on('reports:channels:dateRangeChange',
                    function (e, message) {
                        $scope.query = message;
                        $scope.getData();
                    }
                );

                $scope.getData();



            }
        ]);

})(window.angular);

